import instance from "./axios";

async function authenticateUser(conversationId) {
  const { data } = await instance.post(`/auth/authenticate/${conversationId}`);

  return data;
}

export { authenticateUser };
